export default "__VITE_PUBLIC_ASSET__b94046a3__"